import $ from "jquery";

import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

const weAreCoWorkersBottom = (el) => {
    let $el = $(el);

    if ($el.length === 0) {
        throw new Error(
            "Element not found for Swiper initialization [WeAreCoWorkersBottom-Swiper]"
        );
    }
    let bottomSplide = new Splide(el, {
        autoScroll: {
            speed: -1,
        },
        type: "loop",
        autoWidth: true,
        cloneStatus: false,
        pagination: false,
        arrows: false,
        updateOnMove: true,
        gap: "2.4rem",
        autoHeight: true,
    }).mount({ AutoScroll });
};

export default weAreCoWorkersBottom;
